import { LeadBannerTriggerReason } from '@/entities/analytics';
import type { AlternativeSearchView } from '../model/alternativeSearch/types';

const NOTICE_LEAD_BANNER_TRIGGER_REASONS: Record<AlternativeSearchView['kind'], LeadBannerTriggerReason> = {
  departureCity: LeadBannerTriggerReason.AlternativeSerp,
  similar: LeadBannerTriggerReason.AlternativeSerp,
  notFound: LeadBannerTriggerReason.EmptySerp,
};

export function getNoticeLeadBannerTriggerReason(view: AlternativeSearchView | null): LeadBannerTriggerReason {
  return view ? NOTICE_LEAD_BANNER_TRIGGER_REASONS[view.kind] : LeadBannerTriggerReason.EmptySerp;
}
